import React, { lazy } from 'react';
import { DashboardOutlined } from '@ant-design/icons';
import LandingPage from './landingScreen/LandingPage';
const HomeScreen = lazy(() => import('./homeScreen/HomeScreen'));
const PricingScreen = lazy(() => import('./homeScreen/components').then((m) => ({ default: m.PricingScreen })));
const ModelCostScreen = lazy(() => import('./homeScreen/ModelCostScreen'));
const AboutScreen = lazy(() => import('./aboutScreen/AboutScreen'));
const ContactScreen = lazy(() => import('./contactScreen/ContactScreen'));
const PrivacyScreen = lazy(() => import('./privacyScreen/PrivacyScreen'));
const TermsScreen = lazy(() => import('./termsScreen/TermsScreen'));
const FaqScreen = lazy(() => import('./faqScreen/FaqScreen'));
const FeaturesScreen = lazy(() => import('./featuresScreen/FeaturesScreen'));
const DocsScreen = lazy(() => import('./docsScreen/DocsScreen'));
const McpScreen = lazy(() => import('./mcpScreen/McpScreen'));

const routes = [
  {
    key: 'mcpscreen',
    title: 'MCP',
    component: <McpScreen />,
    icon: null,
    permissions: [],
    path: '/mcp',
    sidebar: false,
  },
  {
    key: 'developersscreen',
    title: 'Developers',
    component: <HomeScreen />,
    icon: <DashboardOutlined />,
    permissions: [],
    path: '/developers',
    sidebar: false,
  },
  {
    key: 'pricingscreen',
    title: 'Pricing',
    component: <PricingScreen />,
    icon: null,
    permissions: [],
    path: '/pricing',
    sidebar: false,
  },
  {
    key: 'aboutscreen',
    title: 'About',
    component: <AboutScreen />,
    icon: null,
    permissions: [],
    path: '/about',
    sidebar: false,
  },
  {
    key: 'modelcostscreen',
    title: 'Model Costs',
    component: <ModelCostScreen />,
    icon: null,
    permissions: [],
    path: '/model-costs',
    sidebar: false,
  },
  {
    key: 'contactscreen',
    title: 'Contact',
    component: <ContactScreen />,
    icon: null,
    permissions: [],
    path: '/contact',
    sidebar: false,
  },
  {
    key: 'featuresScreen',
    title: 'Features',
    component: <FeaturesScreen />,
    icon: null,
    permissions: [],
    path: '/features',
    sidebar: false,
  },
  {
    key: 'docsScreen',
    title: 'Documentation',
    component: <DocsScreen />,
    icon: null,
    permissions: [],
    path: '/docs',
    sidebar: false,
  },
  {
    key: 'faqScreen',
    title: 'FAQ',
    component: <FaqScreen />,
    icon: null,
    permissions: [],
    path: '/faq',
    sidebar: false,
  },
  {
    key: 'privacyScreen',
    title: 'Privacy',
    component: <PrivacyScreen />,
    icon: null,
    permissions: [],
    path: '/privacy',
    sidebar: false,
  },
  {
    key: 'termsScreen',
    title: 'Terms',
    component: <TermsScreen />,
    icon: null,
    permissions: [],
    path: '/terms',
    sidebar: false,
  },
  {
    key: 'landingPage',
    title: 'Home',
    component: <LandingPage />,
    icon: null,
    permissions: [],
    path: '/',
    sidebar: true,
  }
];

/**
 * Filters routes based on user permissions.
 * @returns {Array} Accessible routes
 */
export const getRoutes = () => {
  return routes;
};

export default getRoutes;
